import { Component, OnInit , Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GridOptions } from "ag-grid";
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';

@Component({
  selector: 'd2z-vic-shipment',
  templateUrl: './vic-shipment.component.html',
  styleUrls: ['./vic-shipment.component.css']
})
export class VicShipmentComponent implements OnInit {
  public importList = [];
  public articleList = [];
  


  manifestNumber: string;
  arrayBuffer:any;
  file:File;
  errorMsg: string;
  show: Boolean;
  ReferenceFlag; Boolean;
  public consignment: any;
  ArticleFlag: Boolean;
  successMsg: String;
  userName: String;
  system: String;
  role_id: String;
   gridOptions: GridOptions;
   articlegridOptions:GridOptions;
   autoGroupColumnDef;
   rowGroupPanelShow;
   rowData = [];
  
   defaultColDef;
   consignmentForm: FormGroup;
  referenceNumberForm: FormGroup;
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.show = false;
    this.ReferenceFlag =true;

    this.consignmentForm = new FormGroup({
      user_name: new FormControl(),
      reference_number: new FormControl(),
      serviceType: new FormControl(),
      receiverName: new FormControl(),
      receiverAddress: new FormControl(),
      receiverAddress2: new FormControl(),
      phoneNumber: new FormControl(),
      suburb: new FormControl(),
      state: new FormControl(),
      postcode: new FormControl(),
    });

    this.referenceNumberForm = new FormGroup({
      referenceNumber: new FormControl()
    });
    this.gridOptions = <GridOptions>{ rowSelection: "multiple" };
    this.gridOptions.columnDefs = [
      {
        headerName: "Reference number",
        field: "referenceNumber",
        width: 500,
        checkboxSelection: true,
        headerCheckboxSelection: function(params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        }
      }
    ];
   
    this.autoGroupColumnDef = {
      headerCheckboxSelection: true,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true }
    };      
    this.rowGroupPanelShow = "always";
    this.defaultColDef = {
      editable: true
    };
  }

  ngOnInit() {
      this.system = document.location.hostname.includes("speedcouriers.com.au") == true ? "Speed Couriers" :"D2Z";
      this.getLoginDetails();
     
     
  };

   

  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };
  
 
  saveConsignment() {

    var consignments = [];
    let originalRefNbr = this.referenceNumberForm.value.referenceNumber;
    let brokerName = this.consignmentForm.value.user_name;
    this.consignment.barcodeLabelNumber = this.consignmentForm.value.reference_number+ "CHA";
    this.consignment.datamatrix =  this.consignmentForm.value.reference_number+ "CHA";
    this.consignment.referenceNumber = this.consignmentForm.value.reference_number+ "CHA";
    this.consignment.consigneeAddr1 = this.consignmentForm.value.receiverAddress;
    this.consignment.consigneeAddr2 = this.consignmentForm.value.receiverAddress2;
    this.consignment.consigneeName = this.consignmentForm.value.receiverName;
    this.consignment.consigneePhone = this.consignmentForm.value.phoneNumber;
    this.consignment.consigneeSuburb = this.consignmentForm.value.suburb;
    this.consignment.consigneeState = this.consignmentForm.value.state;
    this.consignment.consigneePostcode = this.consignmentForm.value.postcode;
   
    consignments.push(this.consignment);
    this.spinner.show();
    this.consigmentUploadService.consigmentFileUploadv3(consignments, (resp) => {
      this.spinner.hide();
      console.log(resp)
      if (resp[0].message != 'Success') {
        this.errorMsg =resp[0].message;
      } else {
       
            this.successMsg = 'Consignment Change address request placed successfully';
            this.consignmentForm.reset;
          }
        
    });
  }
  fetchConsignment(){
    this.rowData=[];
    this.errorMsg = null;
    this.successMsg = '';

    if(this.referenceNumberForm.value.referenceNumber == null || this.referenceNumberForm.value.referenceNumber == ''){
      this.errorMsg = "**Please Enter the reference number to fetch consignment details";
    }
   
        this.spinner.show();
        this.consigmentUploadService.getConsignment(this.referenceNumberForm.value.referenceNumber, (resp) => {
          this.spinner.hide();
          if (resp.error) {
            this.errorMsg = "Unable to process the request, please contact us"
          } else {
            console.log("Populate to form: "+ resp.referenceNumber)
            this.consignment = resp;
            this.consignmentForm.controls['reference_number'].setValue(resp.referenceNumber);
            this.consignmentForm.controls['serviceType'].setValue(resp.serviceType);
            this.consignmentForm.controls['receiverName'].setValue(resp.consigneeName);
            this.consignmentForm.controls['receiverAddress'].setValue(resp.consigneeAddr1);
            this.consignmentForm.controls['phoneNumber'].setValue(resp.consigneePhone);
            this.consignmentForm.controls['suburb'].setValue(resp.consigneeSuburb);
            this.consignmentForm.controls['state'].setValue(resp.consigneeState);
            this.consignmentForm.controls['postcode'].setValue(resp.consigneePostcode);
          }
  });
        
    
  }
  onSelectionChange() {
    var selectedRows = this.gridOptions.api.getSelectedRows();
    this.errorMsg = null;
  };

}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/vic-shipment/vic-shipment.component.ts